import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { useHistory } from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { format, addDays, isValid, parse } from 'date-fns';
import Typography from '@material-ui/core/Typography';

import { useParams } from "react-router-dom";

import ComponentAgendamento from './componentAgendamento.js';


export default function EditarAgendamento() {

 

    const history = useHistory();
     const { idAgendamento } = useParams();
 

 
    return (
        <div>
            <NavegadorGestao
                Operacional={true}
                Agendamentos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

               
               < ComponentAgendamento flag={1} idAgendamento={idAgendamento} />

 
        </div >
    );
}


